import { FAQUI } from "features";

const FAQ = () => {
  return (
    <>
      <FAQUI />
    </>
  );
};
export { FAQ };
